import gqlTagGira from 'graphql-tag';

export const VIEW_ITEM_FRAGMENT = gqlTagGira`
  fragment CalendarViewItem on JiraWorkManagementViewItem {
    __typename
    id
    issueId
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      __typename
      ... on JiraDatePickerField {
        fieldId
        aliasFieldId
        name
        date
        fieldConfig {
          isEditable
        }
      }
      ...on JiraSingleLineTextField {
        fieldId
        aliasFieldId
        name
        text
        type
        fieldConfig {
          isEditable
        }
      }
      ...on JiraIssueTypeField {
        fieldId
        name
        issueType {
          issueTypeId
          name
          type
          avatar {
            medium
          }
        }
      }
      ...on JiraPriorityField {
        fieldId
        name
        priority {
          name
          priorityId
          iconUrl
        }
      }
      ... on JiraStatusField {
        fieldId
        name
        status {
          name
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraSingleSelectUserPickerField {
        fieldId
        aliasFieldId
        user {
          picture
          name
          accountId
          accountStatus
          __typename
        }
        fieldConfig {
          isEditable
        }
      }
    }
  }
`;

export const QUERY = gqlTagGira`
  query JWMCalendarPaginatedItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "calendarList", filter:["jql"]) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${VIEW_ITEM_FRAGMENT}
`;

export const CALENDAR_ITEM_DETAILS_QUERY = gqlTagGira`
  query JWMCalendarItemDetails($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
        }
      }
    }
  }
  ${VIEW_ITEM_FRAGMENT}
`;
